import { useState, useContext } from 'react';
import { styled } from '@mui/system';
import { Modal, Box, Button, Drawer } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import useMediaQuery from '@mui/material/useMediaQuery';
import CloseIcon from '@mui/icons-material/Close';
import UserTools from './components/UserTools/UserTools';
import Coffee_pic from '../../../assets/images/Coffee_image2.png';
import Background from '../../../assets/images/background.jpeg';
import LoginModal from '../../../pages/LoginPage/components/LoginModal';
import RegisterModal from '../../../pages/RegisterPage/components/RegisterModal';
import RetrievePasswordModal from '../../../pages/RetrievePasswordPage/components/RetrievePasswordModal';
import { useDispatch } from 'react-redux';
import { logOut } from '../../../store/auth/authSlice';
import { toast } from 'react-toastify';
import { PopupNotification } from '../../shared/PopupNotification/PopupNotification';
import SentEmailPage from '../../../pages/SentEmailPage';
import LinkItems from './components/LinkItems';
import MainMenuItems from './components/MainMenuItems';
import { AppContext } from '../../../context/ContextProvider';

const ToolBarContainer = styled('div')(({ theme }) => ({
  height: '60px',
  width: '100%',
  maxWidth: '100vw',
  backgroundImage: `url(${Background})`,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'fixed',
  zIndex: 2,
  filter: 'drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.3))',
  [theme.breakpoints.down('sm')]: {
    height: '40px',
  },
}));

const Logo = styled('img')({
  height: '60px',
  width: '60px',
  objectFit: 'fill',
  marginTop: '5px',
});

//TODO: change ul to buttons, since the signup and login will pop up a modal,
//      instead of a link
const ActionsOnTheNavBar = styled('ul')({
  display: 'flex',
  justifyContent: 'flex-end',
  listStyle: 'none',
  gap: '6px',
  marginRight: '5vw',
});

const AuthenticationButton = styled(Button)(({ theme }) => ({
  fontFamily: 'Caveat',
  width: '100px',
  height: '60px',
  padding: '16px',
  color: 'white',
  fontSize: '24px',
  fontStyle: 'italic',
  textTransform: 'none',
  [theme.breakpoints.down('sm')]: {
    fontFamily: 'Raleway',
    fontSize: '16px',
    fontStyle: 'normal',
    padding: '0 0 0 10px',
    width: 'auto',
  },
}));

const MenuButton = styled(MenuIcon)(({ theme }) => ({
  color: '#fff',
  margin: '0 15px',
  [theme.breakpoints.down('sm')]: {
    margin: '0 18px',
  },
}));

const MainMenuDrawer = styled(Drawer)({
  '& >.MuiPaper-root': {
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
  },
});

const CloseButton = styled(Button)({
  color: '#fff',
  padding: '0',
  position: 'absolute',
  right: '53px',
  top: '41px',
  minWidth: 'auto',
});
const LogoLink = styled('a')({});

export default function ToolBar(props) {
  const [open, setOpen] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [currentPage, setCurrentPage] = useState('LOGIN');
  const mobileMatch = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const { isShow, setIsShow, isLogin, setIsLogin } = useContext(AppContext);

  const handleClose = () => {
    setOpen(false);
  };
  const closeAfterLogin = () => {
    setOpen(false);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (!open) setOpen(true);
  };

  const handleLoginChange = (state) => {
    setIsLogin(state);
  };

  const AuthPage = (props) => {
    switch (props.page) {
      case 'LOGIN':
        return (
          <LoginModal
            handlePageChange={handlePageChange}
            closeAfterLogin={closeAfterLogin}
            handleLoginChange={handleLoginChange}
          />
        );
      case 'REGISTER':
        return (
          <RegisterModal
            handlePageChange={handlePageChange}
            closeAfterLogin={closeAfterLogin}
            handleLoginChange={handleLoginChange}
          />
        );
      case 'FORGET':
        return <RetrievePasswordModal handlePageChange={handlePageChange} />;
      case 'SENT':
        return <SentEmailPage handlePageChange={handlePageChange} />;
      default:
        return <LoginModal handlePageChange={handlePageChange} />;
    }
  };
  const dispatch = useDispatch();
  const handleLogOut = async () => {
    await dispatch(logOut());
    toast.success('successfully log out');
    setIsLogin(false);
  };

  return (
    <>
      <ToolBarContainer>
        {mobileMatch ? (
          <>
            <MenuButton onClick={() => setOpenDrawer(true)} />
            <MainMenuDrawer anchor={'left'} open={openDrawer} onClose={() => setOpenDrawer(false)}>
              <CloseButton onClick={() => setOpenDrawer(false)}>
                <CloseIcon />
              </CloseButton>
              <MainMenuItems />
            </MainMenuDrawer>
          </>
        ) : (
          <LogoLink href="/">
            <Logo src={Coffee_pic} alt="CoffeeTopia Logo" />
          </LogoLink>
        )}
        {isShow ? (
          isLogin ? (
            <UserTools handleLogOut={handleLogOut} />
          ) : (
            <ActionsOnTheNavBar>
              <li>
                <AuthenticationButton onClick={() => handlePageChange('LOGIN')}>
                  Sign in
                </AuthenticationButton>
              </li>
              <li>
                <AuthenticationButton onClick={() => handlePageChange('REGISTER')}>
                  Register
                </AuthenticationButton>
              </li>
              <Modal
                open={open}
                {...props}
                onClose={handleClose}
                style={{ backdropFilter: 'blur(10px)' }}
                //style={{ backgroundColor: 'rgba(0, 0, 0, 0)', backdropFilter: 'blur(10px)' }}
              >
                <Box>
                  <AuthPage page={currentPage} />
                </Box>
              </Modal>
            </ActionsOnTheNavBar>
          )
        ) : null}
      </ToolBarContainer>
      {mobileMatch && isLogin && <LinkItems />}
      <PopupNotification />
    </>
  );
}
